webpackJsonp([114276838955818,60335399758886],{

/***/ 256:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Find Growth Tools"}}},"layoutContext":{}}

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(637);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(256);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1893:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.70ba58a4.png";

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _signupform = __webpack_require__(636);
	
	var _signupform2 = _interopRequireDefault(_signupform);
	
	var _semanticUiReact = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { inverted: true, vertical: true, style: { padding: '5em 0em', background: '#091621'
	
	      } },
	    _react2.default.createElement(
	      _semanticUiReact.Container,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { divided: true, inverted: true, stackable: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 3 },
	            _react2.default.createElement(_semanticUiReact.Header, { inverted: true, as: 'h4', content: 'Find Tools' }),
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              { link: true, inverted: true },
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/search/' },
	                'Search'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/categories/' },
	                'Category'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/growthlevers/' },
	                'Growth Lever'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/integrations/' },
	                'Integration'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/customers/' },
	                'Customer'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 3 },
	            _react2.default.createElement(_semanticUiReact.Header, { inverted: true, as: 'h4', content: 'About' }),
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              { link: true, inverted: true },
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/about/' },
	                'About FGT'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/suggest/' },
	                'Suggest a tool'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: '/contact/' },
	                'Contact'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { href: 'https://www.growthjobs.io', target: '_blank' },
	                'GrowthJobs.io'
	              ),
	              _react2.default.createElement(_semanticUiReact.List.Item, null),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                '  ',
	                _react2.default.createElement(_semanticUiReact.Button, {
	                  circular: true,
	                  color: 'facebook',
	                  href: 'https://fb.me/findgrowthtools',
	                  target: '_blank',
	                  icon: 'facebook',
	                  size: 'mini'
	                }),
	                _react2.default.createElement(_semanticUiReact.Button, {
	                  circular: true,
	                  color: 'twitter',
	                  href: 'https://twitter.com/FindGrowthTools',
	                  target: '_blank',
	                  icon: 'twitter',
	                  size: 'mini'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 7 },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h4', inverted: true },
	              'Newsletter'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              _react2.default.createElement(_signupform2.default, null)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navmenu = function Navmenu(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Responsive,
	      { maxWidth: 769 },
	      _react2.default.createElement(
	        _semanticUiReact.Menu,
	        {
	          secondary: true
	          // fixed="top"
	          , borderless: true,
	          style: {
	            paddingTop: '5px',
	            //  paddingBottom: '5px',
	            color: '#3a7bd5'
	          }
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Container,
	          { style: { maxWidth: '700px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Item,
	            { as: 'a', href: '/' },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              {
	                style: {
	                  // fontFamily: 'OpenSans-ExtraBold',
	                  fontFamily: 'Open Sans',
	                  fontWeight: '800',
	                  // fontSize: '140px',
	                  fontSize: '30px',
	                  color: 'white',
	                  letterSpacing: '-1.5px'
	                }
	              },
	              ' ',
	              'FindGrowthTools \uD83D\uDE80'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Menu,
	            { position: 'right' },
	            _react2.default.createElement(
	              _semanticUiReact.Dropdown,
	              { text: 'Menu', item: true, pointing: true, style: { color: '#dcddde' } },
	              _react2.default.createElement(
	                _semanticUiReact.Dropdown.Menu,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/search/' },
	                  'Search'
	                ),
	                ' ',
	                _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Header,
	                  null,
	                  'Find by'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/categories/' },
	                  'Category'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/growthlevers/' },
	                  'Growth Lever'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/integrations/' },
	                  'Integration'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/customers/' },
	                  'Customer'
	                ),
	                ' ',
	                _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/about/' },
	                  'About'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/suggest/' },
	                  'Suggest a tool'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/contact/' },
	                  'Contact'
	                )
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Menu.Item, null),
	            _react2.default.createElement(_semanticUiReact.Menu.Item, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Responsive,
	      { minWidth: 770 },
	      _react2.default.createElement(
	        _semanticUiReact.Menu,
	        {
	          secondary: true
	          // fixed="top"
	          , borderless: true,
	          style: {
	            paddingTop: '5px',
	            //  paddingBottom: '5px',
	            color: '#3a7bd5'
	          }
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Container,
	          { style: { maxWidth: '700px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Item,
	            { as: 'a', href: '/' },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              {
	                style: {
	                  // fontFamily: 'OpenSans-ExtraBold',
	                  fontFamily: 'Open Sans',
	                  fontWeight: '800',
	                  // fontSize: '140px',
	                  fontSize: '30px',
	                  color: 'white',
	                  letterSpacing: '-1.5px'
	                }
	              },
	              ' ',
	              'Find',
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: '900' } },
	                'GrowthTools'
	              ),
	              ' \uD83D\uDE80'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Menu,
	            { position: 'right' },
	            _react2.default.createElement(
	              _semanticUiReact.Menu.Item,
	              { style: { color: '#dcddde' }, href: '/search/' },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	              'Search'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Dropdown,
	              {
	                text: 'Find Tools',
	                item: true,
	                pointing: true,
	                style: { color: '#dcddde' }
	              },
	              _react2.default.createElement(
	                _semanticUiReact.Dropdown.Menu,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Header,
	                  null,
	                  'Find by'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/categories/' },
	                  'Category'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/growthlevers/' },
	                  'Growth Lever'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/integrations/' },
	                  'Integration'
	                ),
	                ' ',
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  { href: '/customers/' },
	                  'Customer'
	                ),
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Menu.Item,
	              {
	                position: 'right',
	                style: { color: '#dcddde' },
	                href: '/about/'
	              },
	              'About'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Menu.Item,
	              { style: { color: '#dcddde' }, href: '/suggest/' },
	              'Suggest a tool'
	            ),
	            _react2.default.createElement(_semanticUiReact.Menu.Item, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Navmenu;
	module.exports = exports['default'];

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Signupform = function Signupform() {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        textAlign: 'center',
	        display: 'inlineBlock'
	      }
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Form,
	      {
	        name: 'newslettersignupForm'
	        // netlify-honeypot="bot-field"
	        , action: '/thanks'
	        // netlify
	        , size: 'large',
	        method: 'post',
	        'data-netlify': 'true',
	        'data-netlify-honeypot': 'bot-field',
	        style: {
	          display: 'inline-block'
	        }
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'newslettersignupForm' }),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Group,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Form.Field,
	          null,
	          _react2.default.createElement(_semanticUiReact.Form.Input, { type: 'email', placeholder: 'Email', name: 'email' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { primary: true, type: 'submit' },
	          'Subscribe'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          style: {
	            display: 'none'
	          }
	        },
	        _react2.default.createElement('input', { name: 'bot-field' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The latest growth tools straight to your inbox.'
	      )
	    )
	  );
	};
	
	exports.default = Signupform;
	module.exports = exports['default'];

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _footer = __webpack_require__(634);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(763);
	
	__webpack_require__(762);
	
	var _navmenu = __webpack_require__(635);
	
	var _navmenu2 = _interopRequireDefault(_navmenu);
	
	var _favicon = __webpack_require__(1893);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        // backgroundColor: '#fbfbfb'
	      }
	    },
	    _react2.default.createElement('div', {
	      style: {
	        top: '-300px',
	        // background: 'linear-gradient(to bottom right, #373B44, #4286f4)',
	        background: '#091621',
	
	        position: 'fixed',
	        transform: 'skewY(-10deg)',
	
	        height: 700,
	        maxHeight: 700,
	        width: '100%',
	        zIndex: -3
	      }
	    }),
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{
	        name: 'keywords',
	        content: 'Growth software, growth marketing, growth hacking'
	      }],
	      link: [{ rel: 'shortcut icon', type: 'image/png', href: '' + _favicon2.default }]
	    }),
	    _react2.default.createElement(_navmenu2.default, { siteTitle: data.site.siteMetadata.title }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          // maxWidth: 960,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	          //  marginTop: '4em',
	          // backgroundColor: '#fbfbfb'
	        }
	      },
	      children()
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b28826accdd96ba39069.js